import { render } from "./view-more.vue?vue&type=template&id=56a6eacf"
import script from "./view-more.vue?vue&type=script&lang=js"
export * from "./view-more.vue?vue&type=script&lang=js"

import "./view-more.vue?vue&type=style&index=0&id=56a6eacf&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/view-more.vue'],['render',render],['__file',"view-more.vue"]])

export default __exports__